<template>
    <v-container>
        <v-card
            elevation="5"
            style="padding:30px"
        >
            <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    align="center" 
                >
                    <v-avatar color="#DCDCDC" size="70" style="border-radius: 50%; !important">
                        <span class="white--text headline">{{initials}}</span>
                    </v-avatar>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    align="center" 
                >
                    <span><b>OLÁ, {{userName}}</b></span>
                    <br />
                    <span>{{userEmail}}</span>
                    <br /><h6> v.: 2204</h6>
                </v-col>
            </v-row>
        </v-card>
        <div v-for="(item, i) in items" :key="i" style="margin-top:150px">
            <v-btn block x-large elevation="5" @click="confirmLogout">
                {{item.text}}
                <v-icon
                    right
                    dark
                >
                    mdi-logout
                </v-icon>
            </v-btn>
        </div>
        <v-dialog
            v-model="dialog.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialog.title}}
                </v-card-title>

                <v-card-text>
                    {{dialog.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.show = false"
                    >
                        Não
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="logout"
                    >
                        Sim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
      items: [
        { text: 'Sair' },
      ],
      userName: '',
      userEmail: '',
      initials: '',
      dialog: {
        show: false,
        title: '',
        message: ''
    },
    }),

    created(){
        let loginData = JSON.parse(localStorage.getItem("loginData"));

        this.userName = loginData.userData.name;
        this.userEmail = loginData.userData.login;

        let arrInitials = loginData.userData.name.split(" ");

        if(arrInitials.length >= 2){
            this.initials = `${arrInitials[0].substr(0,1).toUpperCase()}${arrInitials[1].substr(0,1).toUpperCase()}`;
        }
        else if(arrInitials.length == 1){
            this.initials = arrInitials[0].substr(0,2).toUpperCase();
        }
    },

    methods: {
        confirmLogout(){
            this.dialog.title = "Sair";
            this.dialog.message = "Deseja realmente sair?";
            this.dialog.show = true;
        },
        logout(){
            localStorage.removeItem("loginData");
            this.$router.push('/');
        }
    }
  }
</script>